import { Suspense, lazy } from 'react'
import Hero from './Hero'

const HostingPlans = lazy(() => import('./HostingPlans'))
const ComplementsSection = lazy(() => import('./ComplementsSection'))

const Home = () => {
  return (
    <div>
      <Hero />
      <div className="md:hidden text-center py-8 px-4 dark:bg-slate-950">
        <h1 className="text-4xl font-extrabold leading-tight text-gray-900 dark:text-white mb-2">Movete libremente</h1>
        <p className="text-lg font-normal leading-snug text-gray-600 dark:text-gray-300">Hosting flexible, seguro y escalable</p>
      </div>
      <Suspense fallback={<div className="py-20 text-center text-gray-500">Cargando planes...</div>}>
        <HostingPlans />
      </Suspense>
      <Suspense fallback={null}>
        <ComplementsSection />
      </Suspense>
    </div>
  )
}

export default Home
